var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subscription-box-order-fraud-review-detail"},[_c(_setup.SubscriptionBoxOrderFraudReview,{attrs:{"id":_vm.id,"embedded":false,"show-actions":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }